import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import RestockingProductComponent from '../components/RestockingProductComponent';
import { validateSession } from  '../utils/functions';
import { normalizarImporte } from '../utils/formats';
import { currencySymbol } from '../utils/enums';
import { navigateTo } from '../utils/navigation';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

var config = process.env;

class AddRestockingPage extends Component {

	constructor(){
        super();
        this.state = {
            disabled: false,
            checked: false,
            dateSelected: null,
            role: 0,
            products: {},
            providers: [],
            // Comprobante de la factura: se sube en el MISMO flujo que la reposición.
            archivoFactura: null,
            invoice: null,
            invoiceLink: null,
            invoiceTotal: '',
            selectedProvider: "999",
            orderId: null,
            orderItems: []
        }
	}

	async componentDidMount() {
        let role = await validateSession()
        this.setState({ checked: true, role:  role});
        await this.getProviders();

        // Pre-cargar desde pedido pendiente si viene ?orderId en la URL
        const params = new URLSearchParams(window.location.search);
        const orderId = params.get('orderId');
        if (orderId) {
            this.setState({ orderId: parseInt(orderId) });
            await this.loadFromOrder(parseInt(orderId));
        }
    }

    loadFromOrder = (orderId) => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider-orders/' + orderId, request)
        .then(res => res.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }
            const order = data.data;
            this.setState({
                selectedProvider: String(order.providerId),
                orderItems: order.items
            });
        });
    }

    getProviders = () => {
        var request = {
            method: 'GET',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider/product', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.setState({
                    providers: data.data,
                });
            }
        });
    }

    handlerSelectProduct = (value) => {
        this.setState({products: value});
    }

    save = () => {
        if (Object.keys(this.state.products).length === 0) {
            alert("Agregue al menos 1 producto");
            return;
        }
        var provider = document.getElementById('provider').value;
        if (provider === "999")
        {
            alert("Seleccione proveedor");
            return;
        }       
        if (this.state.dateSelected == null)
        {
            alert("Ingresar fecha de la factura");
            return;
        }       
        // ENI-32: los datos de factura sólo se exigen si el proveedor factura al entregar.
        if (!this.esConsignante())
        {
            // `trim()` y no `== null`: escribir el número y borrarlo deja '' — que pasaba esta
            // guarda y hacía nacer la reposición SIN factura, o sea con deuda $0 y sin ninguna
            // pantalla desde la cual repararlo. El backend ahora también lo rechaza (6230).
            if (String(this.state.invoice || '').trim() === '')
            {
                alert("Ingresar numero de factura");
                return;
            }
            // ENI-94: el total de la factura es obligatorio y debe ser > 0 (no alcanza con
            // != null: el default era 0 y pasaba la validación sin que el usuario lo cargue).
            if (!(normalizarImporte(this.state.invoiceTotal) > 0))
            {
                alert("Ingresar el monto total que dice la factura, mayor a 0 y SIN puntos de miles.\n\nEjemplo: 12500.50 (no 12.500)");
                return;
            }
        }
        //Convert to dic to list
        var products = [];
        for (const [key, value] of Object.entries(this.state.products)) {
            products.push(value);
        }
        
        this.setState({ disabled: true });
        var token = localStorage.getItem('token');
        var request = {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'access-token': token
            },
            body: JSON.stringify({
                date: this.state.dateSelected,
                provider: parseInt(provider),
                products: products,
                // Columna deprecada: se manda el 2 fijo ("pendiente") sólo para que un rollback
                // del código pueda leerla. El estado real se fija pagando en Facturas a pagar.
                paymentStatus: 2,
                // Sin factura no se mandan campos vacíos: `parseInt(null)` es NaN y viajaría
                // como null igual, pero ser explícito evita que el backend reciba basura.
                invoice: this.esConsignante() ? null : this.state.invoice,
                invoiceLink: this.esConsignante() ? null : this.state.invoiceLink,
                invoiceTotal: this.esConsignante() ? null : normalizarImporte(this.state.invoiceTotal),
                ...(this.state.orderId ? { orderId: this.state.orderId } : {})
            })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'restocking', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
                // Sin esto la pantalla quedaba con el botón deshabilitado para siempre después
                // de un error: había que recargar y volver a tipear todo.
                this.setState({ disabled: false });
                return;
            }
            // La reposición YA existe. Si el comprobante falla, se avisa y se sigue igual: no
            // tiene sentido dejar al usuario en el form de una reposición que ya se guardó.
            const invoiceId = data.data && data.data.providerInvoiceId;
            this.subirComprobante(invoiceId).then(() => navigateTo('/restocking'));
        })
        .catch(() => {
            alert('No se pudo guardar la reposición. Revisá la conexión.');
            this.setState({ disabled: false });
        });
    }

    // El comprobante viaja aparte (multipart) y DESPUÉS de que la factura existe, porque el path
    // del objeto se arma con su id. Mismo endpoint que usa Facturas a pagar.
    subirComprobante = (invoiceId) => {
        if (!this.state.archivoFactura) return Promise.resolve(true);
        if (!invoiceId) {
            // Pasa con un proveedor consignante: no emite factura al dejar la mercadería, así que
            // no hay documento al que colgarle el comprobante.
            alert('La reposición se guardó, pero no tiene factura asociada, así que el comprobante no se subió.');
            return Promise.resolve(false);
        }
        const datos = new FormData();
        datos.append('file', this.state.archivoFactura);
        return fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}providerInvoice/${invoiceId}/file`, {
            method: 'POST',
            // Sin Content-Type a propósito: lo pone el navegador con el boundary del multipart.
            headers: { 'access-token': localStorage.getItem('token') },
            body: datos,
        })
            .then((r) => r.json())
            .then((resp) => {
                if (resp.error > 0) {
                    alert(`La reposición se guardó, pero el comprobante no se pudo subir:\n${resp.message}\n\nSubilo desde Facturas a pagar.`);
                    return false;
                }
                return true;
            })
            .catch(() => {
                alert('La reposición se guardó, pero el comprobante no se pudo subir. Subilo desde Facturas a pagar.');
                return false;
            });
    }

    renderProviders = () => {
        var items = [];
        this.state.providers.forEach(element => {
            items.push(
                <option key={element.providerId} value={element.providerId}>{ element.name }</option>
            )
        });
        return (
            <select id="provider" className="custom-select" value={this.state.selectedProvider} onChange={(e) => this.onChangeProvider(e)}>
                <option value="999">Seleccione proveedor</option>
                { items }
            </select>
        );
    }

    // ENI-32: un proveedor consignante no emite factura al dejar la mercadería (factura recién
    // cuando se le liquida lo vendido). Pedirle número, link y monto obligaba a inventar datos
    // para poder registrar la entrada de stock.
    esConsignante = () => {
        const elegido = (this.state.providers || []).find(
            (p) => String(p.providerId) === String(this.state.selectedProvider),
        );
        return !!(elegido && Number(elegido.is_consignment) === 1);
    }

    // La moneda del proveedor elegido. La factura que esta pantalla crea la HEREDA, así que el
    // operador tiene que ver en qué moneda está tipeando: el número va tal cual lo dice el papel,
    // y sin el cartel no hay nada que distinga "254" de USD 254 de $254.
    monedaProveedor = () => {
        const elegido = (this.state.providers || []).find(
            (p) => String(p.providerId) === String(this.state.selectedProvider),
        );
        return elegido && elegido.currency != null ? Number(elegido.currency) : 1;
    }

    // Cambiar de proveedor descarta los datos de factura tipeados. Es obligatorio, no cosmético:
    // el flujo diseñado por D2/D8 es tener dos fichas del mismo proveedor (una consignante y una
    // no), y alternar entre ellas re-monta los inputs vacíos sin tocar el state.
    onChangeProvider = (e) => {
        this.setState({
            selectedProvider: e.target.value,
            invoice: null,
            invoiceLink: null,
            invoiceTotal: '',
            // El archivo también: si se cambia a un consignante, la factura a la que se iba a
            // colgar deja de existir. El input se re-monta vacío, así que dejarlo en el state
            // subiría un comprobante que el usuario ya no ve elegido.
            archivoFactura: null,
        });
    }

    onChangeInvoice = (e) => {
        console.log(e.target.value)
        this.setState({ invoice: e.target.value });
    }
    onChangeInvoiceLink = (e) => {
        console.log(e.target.value)
        this.setState({ invoiceLink: e.target.value });
    }
    onChangeInvoiceTotal = (e) => {
        console.log(e.target.value)
        this.setState({ invoiceTotal: e.target.value });
    }
    renderGenericData = () => {
        return(
            <div className="col-lg-12">
                <div className="card card-small mb-4">
                    <div className="card-header border-bottom">
                        <h6 className="m-0">Datos generales</h6>
                    </div>
                <ul className="list-group list-group-flush">
                    <li className="list-group-item p-3">
                    <div className="row">
                        <div className="col">
                            <div className="form-row">
                                <div className="form-group col-md-4">
                                    <label>Proveedor *</label>
                                    { this.renderProviders() }
                                </div>
                                <div className="form-group col-md-4">
                                    <label htmlFor="phone">Fecha *</label>
                                    <DatePicker 
                                        className="form-control" 
                                        dateFormat="dd/MM/yyyy"
                                        selected={this.state.dateSelected} 
                                        onChange={(date) => this.setState({ dateSelected: date })}                                         
                                    />
                                </div>
                                {this.esConsignante() ? (
                                    <div className="form-group col-md-8">
                                        <div className="alert alert-info py-2 mb-0" style={{ fontSize: '13px' }}>
                                            <b>Proveedor en consignación.</b> No lleva factura: la mercadería entra al
                                            stock y no se debe nada hasta que se venda. La deuda se genera después,
                                            desde <b>Facturas a pagar → Liquidar consignados</b>.
                                        </div>
                                    </div>
                                ) : (
                                <>
                                <div className="form-group col-md-4">
                                    <label>Numero de factura *</label>
                                    <input autoComplete="off" className="form-control" type="text" id="invoice" placeholder="Numero de factura" value={this.state.invoice || ''} onChange={(e) => this.onChangeInvoice(e)} />
                                </div>
                                <div className="form-group col-md-4">
                                    <label>Link a la factura</label>
                                    <input autoComplete="off" className="form-control" type="text" id="invoiceLink" placeholder="https://…" value={this.state.invoiceLink || ''} onChange={(e) => this.onChangeInvoiceLink(e)} />
                                    <small className="text-muted">Opcional: sólo si el comprobante vive en otro lado.</small>
                                </div>
                                <div className="form-group col-md-4">
                                    <label>Comprobante de la factura</label>
                                    <input type="file" name="restockingInvoiceFile" className="form-control-file"
                                        accept="application/pdf,image/jpeg,image/png,image/webp"
                                        onChange={(e) => this.setState({ archivoFactura: e.target.files[0] || null })} />
                                    <small className="text-muted">
                                        PDF o foto, hasta 10 MB. Se sube junto con la reposición y queda colgado de la
                                        factura. Sólo lo ven los usuarios con acceso: no es un link público.
                                    </small>
                                </div>
                                <div className="form-group col-md-4">
                                    <label>Monto total de la factura *</label>
                                    {/* `type="number"` y no text: con texto libre, tipear el importe como está en el
                                        papel ("12.500") lo guardaba como $12 — y desde ENI-32 ese número es el que
                                        se le paga al proveedor y el que se asienta en caja. */}
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">{currencySymbol(this.monedaProveedor())}</span>
                                        </div>
                                        <input autoComplete="off" className="form-control" type="number" step="0.01" min="0" id="invoiceTotal" placeholder="12500.00" value={this.state.invoiceTotal} onChange={(e) => this.onChangeInvoiceTotal(e)} />
                                    </div>
                                    <small className="text-muted">
                                        Sin puntos de miles. El monto <b>tal como lo dice la factura</b>, en
                                        {' '}{currencySymbol(this.monedaProveedor())} — no lo convertido. La moneda sale de la ficha
                                        del proveedor; se cambia desde Proveedores.
                                    </small>
                                </div>
                                </>
                                )}
                            </div>
                        </div>
                    </div>
                    </li>
                </ul>
                </div>
            </div>
        );
    }

	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (  
                <div className="container-fluid">
                    <div className="row">
                        <SidebarComponent itemSelected={13} role={this.state.role}/>
                        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4" style={{paddingBottom: '80px'}}>
                                <HeaderComponent title="Dashboard" subtitle="Nueva reposición de stock"/>
                                {this.state.orderId && (
                                    <div className="alert alert-info">
                                        Cargando desde pedido a proveedor <strong>#{this.state.orderId}</strong>. Ajuste cantidades y precios antes de confirmar.
                                    </div>
                                )}
                                { this.renderGenericData() }
                                <RestockingProductComponent onChangeData={ this.handlerSelectProduct } selectedProvider={this.state.selectedProvider} preloadedItems={this.state.orderItems}/>
                                <div style={{float: "right", marginRight: "15px"}}>
                                    <button type="button" className="mb-2 btn btn-outline-secondary" style={{width: "200px", marginRight: "10px"}} onClick={() => navigateTo('/restocking')}>Cancelar</button>
                                    <button disabled={this.state.disabled} type="button" className="mb-2 btn btn-primary" style={{width: "200px"}} onClick={() => this.save()}>Cargar</button>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            );
        }
    }
}

export default AddRestockingPage;
